// extracted by mini-css-extract-plugin
module.exports =  {"root":"AX69iuHWxGTI8hQJri8F"};